"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CatalogChips_1 = __importDefault(require("./CatalogChips"));
exports.default = CatalogChips_1.default;
